import { Trip } from './../classes.js';
import { notification } from './../function/notification.js';

export class cTripAttributes {
	constructor() {
		
		this.physical = [
			"Exertion like walking 0 - 1 miles per day."
			, "Exertion like walking 1 - 2 miles per day."
			, "Exertion like walking 2 - 3 miles per day."
			, "Exertion like walking 3 - 4 miles per day."
			, "Exertion like walking 4 - 5 miles per day."
			, "Exertion like walking 5 - 6 miles per day."
			, "Exertion like running 2 - 3 or walking 7 - 9 miles per day."
			, "Exertion like running 3 - 5 or walking 9 - 14 miles per day."
			, "Exertion like running 5 - 7 or walking 14 - 18 miles per day."
			, "Exertion like running 7+ or walking 18+ miles per day."
		];
		this.gear = [
			"$0.00 - $150.00 of specialized gear cost"
			, "$150.00 - $300.00 of specialized gear cost"
			, "$300.00 - $450.00 of specialized gear cost"
			, "$450.00 - $600.00 of specialized gear cost"
			, "$600.00 - $750.00 of specialized gear cost"
			, "$750.00 - $900.00 of specialized gear cost"
			, "$900.00 - $1050.00 of specialized gear cost"
			, "$1050.00 - $1200.00 of specialized gear cost"
			, "$1200.00 - $1350.00 of specialized gear cost"
			, "$1350.00+ of specialized gear cost"
		];
		this.prep = [
			"0 - 2 hours of preperation"
			, "2 - 4 hours of preperation"
			, "4 - 6 hours of preperation"
			, "6 - 8 hours of preperation"
			, "8 - 10 hours of preperation"
			, "10 - 14 hours of preperation"
			, "14 - 20 hours of preperation"
			, "20 - 30 hours of preperation"
			, "30 - 60 hours of preperation"
			, "60+ hours of preperation"
		];
		
		$('body').on('click', '.trip_attributes--open', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.open();
		})
		
		$('body').on('click', '.trip_attributes--close', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.close();
		})
		
		$('body').on('input', '#attributes input[type="range"]', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.update_input_visual($(this));
		})
		
		$('body').on('change', '#attributes input', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.update_input_val($(this));
		})
		
		$('body').on('click', '#attributes #attributes--save', {obj: this}, function(e){
			e.preventDefault();
			
			Trip.save();
			e.data.obj.close();
		})
	}
	
	
	open(){
		$('#trip_attributes').css("display", "flex").hide().fadeIn(200);
		this.set_attributes();
	}
	
	
	close(){
		//close the display
		$('#trip_attributes').fadeOut(200);
	}
	
	
	set_attributes(){
		//set vars and display for this
		let phys_val = $('.physical_level').val() - 1;
		let gear_val = $('.gear_level').val() - 1;
		let prep_val = $('.prep_level').val() - 1;
		
		$('.physical_level').siblings('.range_description').text(this.physical[parseInt(phys_val)]);
		$('.gear_level').siblings('.range_description').text(this.gear[parseInt(gear_val)]);
		$('.prep_level').siblings('.range_description').text(this.prep[parseInt(prep_val)]);
	}
	
	update_input_visual($input){
		let update_text = 0;
		let update_val = $input.val() - 1;
		
		if($input.hasClass('physical_level')){
			update_text = this.physical[parseInt(update_val)];
		}
		if($input.hasClass('gear_level')){
			update_text = this.gear[parseInt(update_val)];
		}
		if($input.hasClass('prep_level')){
			update_text = this.prep[parseInt(update_val)];
		}
		
		$input.siblings('.range_description').text(update_text);
	}
	
	update_input_val($input){
		let name = $input.attr('name');
		let val = $input.val();
		let $target = '';
		
		if($input.attr('type') == 'checkbox'){
			if ($input.prop('checked')) {
				val = 1;
			}else{
				val = 0;
			}
		}
		
		switch(name){
			case 'manage_adult_count':
				$target = $('input[name="trip_adult_count"]');
				break;
			case 'manage_child_count':
				$target = $('input[name="trip_child_count"]');
				break;
			case 'manage_physical_flagged':
				$target = $('input[name="trip_physical_flagged"]');
				break;
			case 'manage_gear_flagged':
				$target = $('input[name="trip_gear_flagged"]');
				break;
			case 'manage_prep_flagged':
				$target = $('input[name="trip_prep_flagged"]');
				break;
			case 'manage_physical_level':
				$target = $('input[name="trip_physical_level"]');
				break;
			case 'manage_gear_level':
				$target = $('input[name="trip_gear_level"]');
				break;
			case 'manage_prep_level':
				$target = $('input[name="trip_prep_level"]');
				break;
		}
		
		if($target != ''){
			if(val == ''){
				val = 0;
			}
			$target.val(val);
		}
		
	}
	
}